import { Heading, Inline, Stack, Text } from '@etg/wings';
import { css } from '@eti/styles';
import { constants } from '@eti/utils';
import BidirectionalSeparatedElements from '../../../../../common/bidirectional-component/BidirectionalSeparatedElements';
import type { TripSegmentType } from '../../../models';
import type { TravelerProductPreference } from './utils';

const segmentPreferencesWrapperStyles = css`
  justify-content: space-between;
`;

const segmentHeaderStyles = css`
  font-weight: 700;
`;

export interface SegmentPreferencesProps {
  travelerPreferences: TravelerProductPreference[];
  segment: NonNullable<TripSegmentType>;
}

const SegmentPreferences = ({ segment, travelerPreferences }: SegmentPreferencesProps) => (
  <Stack spacing={8}>
    <Heading level={4}>
      <BidirectionalSeparatedElements
        className={segmentHeaderStyles}
        data-testid={`segment-title-${segment.segmentId}`}
        elements={[segment.origin.cityName, segment.destination.cityName]}
      />
    </Heading>
    <div role="list">
      {travelerPreferences?.map(
        (travelerPreference: TravelerProductPreference, travelerPreferenceIndex: number) => (
          <Inline
            className={segmentPreferencesWrapperStyles}
            data-testid={`traveler-preference-${segment.segmentId}-${travelerPreferenceIndex}`}
            key={`traveler-preference-${segment.segmentId}-${travelerPreferenceIndex}`}
            role="listitem"
          >
            <Text className={constants.MOUSE_FLOW_CLASS_NAMES}>
              {travelerPreference.travelerName}
            </Text>
            <Text>{travelerPreference.preference}</Text>
          </Inline>
        ),
      )}
    </div>
  </Stack>
);

export default SegmentPreferences;
